module.exports = __webpack_public_path__ + "static/media/5.100d6de5.webp";